(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	/*
		This directive provides the an editor for a specific product
		property. It uses needs scope provides for the property. It provides
		a single function to allow for he addition of new attributes.
	*/

	ngModule.directive('productPropertyEditor', function ($SchemaModal, $uibModal) {
		return {
			scope: {
				property: '='
			},
			templateUrl: 'directives/productPropertyEditor/table.html',
			controller: function($scope) {
				/* If we get a property without attributes, then create an array. */
				if (!$scope.property.attributes) $scope.property.attributes = [];

                console.log('property attributes', $scope.property);

				/* Setup an initial values for a name and price. */
				$scope.new = { name: '', price: 0 };

				/* Function to add a new attributes. */
				$scope.add = function() {
					$scope.property.attributes.push(angular.copy($scope.new));
                    $scope.new = { name: '', price: 0 };
				};

                $scope.delete = function(idx) {

                    let scope = $scope; // need this inside the controller for the modal

                    let modalInstance = $uibModal.open({
                        animation: true,
                        windowClass: 'topmost',
                        backdropClass: 'topmost',
                        template: `
                            <div class="modal-header">
                                <h3 class="modal-title">Remove this attribute?</h3>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-default" type="button" ng-click="cancel()">Cancel</button>
                                <button class="btn btn-danger" type="button" ng-click="delete()">Delete</button>
                            </div>`,
                        controller: function($scope, $uibModalInstance, idx) {

                            $scope.delete = function () {

                                scope.property.attributes.splice(idx, 1);

                                $uibModalInstance.close(idx);
                            };

                            $scope.cancel = function () {
                                $uibModalInstance.dismiss('cancel');
                            };

                        },
                        resolve: {
                            idx: function() {
                                return idx;
                            }
                        },
                        size: 'sm'
                    });


                };

                $scope.edit = function(idx, attribute) {
                    console.log(attribute);

                    var submit = function(form, data, close) {
                        close();
                        $scope.order.$save();
                    };

                   var form = [
                       "name",
                       {
                          key: "price",
                          options: {
                            unit: '$'
                          }
                       },
                       {
                          key: "selected",
                          type: "checkbox"
                       },
                       {
                           key: "default",
                           type: "checkbox"
                       },
                       {
                         type:  "submit",
                         title: "Update"
                       }
                   ];

                   var schema = {
                      type: "object",
                      properties: {
                        "name": {
                            "type": "string",
                            "title": "Attribute Name",
                        },
                        "price": {
                            "type": "number",
                            "title": "Price",
                            "format": "currency"
                        },
                        "selected": {
                            "type": "boolean",
                            "title": "Active",
                        },
                        "default": {
                            "type": "boolean",
                            "title": "Default",
                        }
                      },
                      required: [ "name", "price" ]
                   };

                   $SchemaModal.open('Edit Attribute', attribute, schema, form, submit);

                };
			}
		};

	});

})();
